import 'core-js/stable'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.scss'

Vue.config.productionTip = false
Vue.use(ElementUI)

const app = new Vue({
  router,
  store,
  render: h => h(App)
})

// 应用启动时加载活动配置
store.dispatch('loadContestConfig').finally(() => {
  app.$mount('#app')
})